import React from "react";
import './Cercle.scss'

function Cercle({color}) {
  return <div className={'cercle'+(color ? ' color' : '')}>
    <div className='texture'></div>
  </div>;
}
export default Cercle;
